import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import firebase from "./../helpers/Firestore";

const remoteConfig = firebase.remoteConfig();

const useStyles = makeStyles((theme) => ({
  centerText: {
    textAlign: "center",
  },
}));

const Confirm = (props) => {
  const classes = useStyles();
  return (
    <div className="confirm-container">
      <div className="flex-container">
        <Typography className={classes.centerText} component="p" variant="inherit">
          {remoteConfig.getValue('send_email_text').asString()}
        </Typography>
      </div>
      <div className="flex-container">
        <Button
          onClick={props.handleCalculateAgain}
          variant="contained"
          color="secondary"
        >
          {remoteConfig.getValue('button_pac').asString()}
        </Button>
      </div>
    </div>
  );
};

export default Confirm;